var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"s-integrations-info"}},[(_vm.activeSideTab === 'categories')?_c('IntegrationsSection',{attrs:{"partnerSettings":_vm.partnerSettings,"screen":_vm.screen,"update":_vm.updatePartnerSetting,"currentCorporation":_vm.currentCorporation,"changeStateValue":_vm.changeStateValue}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }